// extracted by mini-css-extract-plugin
export default {"relative":"CloudscapeTable_relative__Nd0cO","tooltip":"CloudscapeTable_tooltip__ESlWB","tooltipOnHover":"CloudscapeTable_tooltipOnHover__OwPrB"};